import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { kartyTagyController } from "../../../controllers/kartytagy.controller";

class ZoznamTagArtikle extends Component {
    state = {
        items: [],
        loading: true,
        selectedArtikelId: null,
        title: null
    };

    shouldComponentUpdate(nextProps) {
        if (this.props.selectedTag !== nextProps.selectedTag || this.props.cisloKarty !== nextProps.cisloKarty) {
            this.getZoznamTagArtikle(nextProps.selectedTag, nextProps.cisloKarty);
            return false;
        }
        return true;
    }

    getZoznamTagArtikle(tag, cisloKarty) {
        this.setState({ loading: true });

        kartyTagyController.getZoznamTagArtikle(tag, cisloKarty).then((response) => {
            let data = JSON.parse(JSON.stringify(response));
            var selectedArtikelId = data[0] ? data[0].idKarty : null;
            this.props.changeSelectedArtikelId(selectedArtikelId);
            this.setState({
                items: data,
                loading: false,
                selectedArtikelId: selectedArtikelId
            });
        });
    }

    renderTable(state) {
        var localizationService = provideLocalizationService(this);
        const { items } = state;
        return (
            <div id="ZoznamTagArtikle">
                <Grid
                    data={items.map((item) => ({ ...item, selected: item.idKarty === state.selectedArtikelId }))}
                    total={items ? items.length : 0}
                    pageSize={items ? items.length : 0}
                    pageable={{ buttonCount: 0, info: true, pageSizes: false, previousNext: false }}
                    selectedField="selected"
                    onRowClick={(e) => {
                        this.props.changeSelectedArtikelId(e.dataItem.idKarty);
                        this.setState({
                            selectedArtikelId: e.dataItem.idKarty
                        });
                    }}>
                    <GridColumn field="tag" title={localizationService.toLanguageString("TagArtikly.Grid.Tag", "Tag")} width="200px" />
                    <GridColumn field="artikle" title={localizationService.toLanguageString("TagArtikly.Grid.Artikle", "Artikle")} />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state);

        return <div>{contents}</div>;
    }
}

export default ZoznamTagArtikle;

registerForLocalization(ZoznamTagArtikle);



// WEBPACK FOOTER //
// ./src/components/dialogs/KartyTagy/ZoznamTagArtikle.js